﻿import { ConfiguratorDI, Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObject } from "@models/configurators/kb-object";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { Output } from "@models/configurators/outputs/output";
import { IDummyNode } from "@models/configurators/kb-object";
import { RuleContainer } from "@models/configurators/rule-container";
import { IBuild } from "@models/entity-models";
import { eOutputType } from "@models/enums";

@Kbo(CToken.Build)
export class Build extends KbObject implements IBuild {
    constructor(kom: KbObjectManager) {
        super(kom);
        this.$outputsNode = { id: this.id + "_outputs", $type: "OutputsNode", allowedChildren: () => [CToken.Output], getParent: () => this };
        this.$rulesNode = { id: this.id + "_rules", $type: "RulesNode", allowedChildren: () => [CToken.Rule], getParent: () => this };
    }

    public idBuildType: number;
    public $outputsNode: IDummyNode;
    public $rulesNode: IDummyNode;

    private _ruleContainers: RuleContainer[];
    @Enumerable()
    public get ruleContainers(): RuleContainer[] {
        if (!this._ruleContainers) this._ruleContainers = [];
        return this._ruleContainers;
    }
    public set ruleContainers(val) {
        this._ruleContainers = val;
    }

    private _outputs: Output[];
    @Enumerable()
    public get outputs(): Output[] {
        if (!this._outputs) this._outputs = [];
        return this._outputs;
    }
    public set outputs(val) {
        this._outputs = val;
    }

    public cloudBuild: boolean;
    public idQueue: number;

    public addOutput(outputType: eOutputType): Output {
        let output = ConfiguratorDI.getNewOutput(outputType, this.$manager);
        this.$manager.addKbObject(output, this);
        this.outputs.push(output);
        return output;
    }

    public removeOutput(output: Output) {
        this.outputs.remove(output);
        this.$manager.removeKbObject(output);
    }

    public removeRuleContainer(rc: RuleContainer) {
        this.$manager.removeKbObject(rc);
        this.ruleContainers.remove(rc);
    }
}
